import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@themesberg/react-bootstrap';

const BackLink = ({ to }) => (
  <Link to={to} className="text-decoration-none btn-quote-back d-inline-flex align-items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-arrow-left-circle me-1"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 8 8 12 12 16" />
      <line x1="16" y1="12" x2="8" y2="12" />
    </svg>
    Back to Listing
  </Link>
);

const EditFormLoader = () => (
  <div className="listing-loader-wrap">
    <button type="button" disabled className="listing-loader-btn">
      <svg
        className="listing-loader-spinner"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="4" style={{ opacity: 0.25 }} />
        <path fill="white" style={{ opacity: 0.75 }} d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
      </svg>
      Loading...
    </button>
  </div>
);

const EditFormLayout = ({ title, subtitle, backTo, loading = false, children }) => (
  <div className="edit-form-page">
    <div className="edit-form-page__header">
      <div>
        <p className="edit-form-page__eyebrow">Edit record</p>
        <h1 className="edit-form-page__title">{title}</h1>
        {subtitle && <p className="edit-form-page__subtitle">{subtitle}</p>}
      </div>
      <BackLink to={backTo} />
    </div>

    <Card border="light" className="edit-form-panel">
      <Card.Body className="edit-form-panel__body">
        {loading ? <EditFormLoader /> : children}
      </Card.Body>
    </Card>
  </div>
);

export default EditFormLayout;
